import {from} from 'rxjs';
import axios from 'axios';
import {ApiUrl} from 'app/static/apiUrls';
import {MapPosition} from 'app/model/mapPosition';
import {mapValues, isObject} from 'lodash';

export class Positions {
    popularCities$() {
        return from(
            Promise.resolve(window.agentsMap.popularCities.map(this._mapCitiesToPosition))
        );
    }

    initialMapSettings$() {
        return from(
            axios.get(ApiUrl.agentsMapSettings)
                .then(({data}) => data)
                .then((data) => mapValues(data, this._mapMapSettingsToNumbers.bind(this)))
                .then((data) => ({
                    position: new MapPosition(data.initialZoom, data.position),
                    zoom: data.defaultZoom,
                }))
        );
    }

    _mapCitiesToPosition({name, localization, zoom}) {
        const mapPosition = new MapPosition(Number(zoom), {
            lat: Number(localization.lat),
            lng: Number(localization.lng),
        });

        return {name, localization: mapPosition};
    }

    _mapMapSettingsToNumbers(element) {
        if (isObject(element)) {
            return mapValues(element, this._mapMapSettingsToNumbers);
        }

        return Number(element);
    }
}